

export function deg_to_rad(deg: number)
{
    return deg * Math.PI / 180
}

export function rad_to_deg(rad: number)
{
    return rad * 180 / Math.PI
}
